// © Microsoft Corporation. All rights reserved.
import React, { useEffect, useState, useRef } from 'react';
import { Separator, Pivot, PivotItem, Stack, CommandButton } from '@fluentui/react';
import { Call, LocalVideoStream, VideoDeviceInfo, LocalAudioStream } from '@azure/communication-calling';
import MediaControls from './MediaControls';
import { CommandPanelTypes } from './CommandPanel';
//import { UserFriendsIcon, SettingsIcon } from '@fluentui/react-icons-northstar';
import { SettingsIcon, ChatIcon, StarIcon, QuestionCircleIcon, UserFriendsIcon } from '@fluentui/react-icons-northstar';
import { Badge } from 'reactstrap/lib';
import { Constants } from 'core/constants';
import {
    headerContainer,
    pivotItemStyles,
    pivotItemStylesInter,
    separatorContainerStyle,
    separatorStyles,
    pivotItemStyle,
    headerCenteredContainer,
    timerDiv,
    timerMobileDiv,
    pivotItemStyleMobile
} from './styles/Header.styles';
import { ParticipantStream } from 'core/reducers';
import CallRecording from '../containers/CallRecording';
import { chatAdd } from 'Utils/chataddapi';
import { postinterviewcomplete, ShowHideEndCallBanner } from 'Utils/interviewcomplete';
import { ParticipantModel, ParticipantInfo, UpdateInterviewTime, uriGid, UpdateInterviewActivityLog, LeaveInterviewCall } from 'Utils/participantInfo';
//import { ConsoleFile, ConsoleString } from 'Utils/participantInfo';
import Banner from './Banner';
import { connection, ShowHideBadge } from 'Utils/SignalRConnection';
import { controlButtonStyle, fullWidth, mediaControlStyles } from './styles/MediaControls.styles';
import CustomPopup from './CustomPopup';
import { Data } from 'popper.js';
import { blurEffectStop } from '../core/sideEffects';


export interface HeaderProps {
    selectedPane: CommandPanelTypes;
    setSelectedPane: any;
    endCallHandler(): void;
    actionable: boolean;
    localVideo: boolean;
    mic: boolean;
    shareScreen: boolean;
    call: Call;
    endCall(): void;
    screenShareStreams: ParticipantStream[];
    activeScreenShareStream: ParticipantStream | undefined;
    localVideoRendererIsBusy: boolean;
    cameraPermission: string;
    microphonePermission: string;
    screenWidth: number;
    setMic(mic: boolean): void;
    setLocalVideoStream(localVideoStream: LocalVideoStream | undefined): void;
    setLocalAudioStream(setLocalAudioStream: LocalAudioStream | undefined): void;
    setScreenShare(screenShare: boolean): void;
    isLocalScreenShareSupportedInBrowser(): boolean;
    localVideoStream: LocalVideoStream | undefined;
    localAudioStream: LocalAudioStream | undefined;
    videoDeviceInfo: VideoDeviceInfo | undefined;
    resetRecordingStatus(): void;
    recordingId: string;
    recordingStatus: string;
}

declare global {
    var commandPanelActive: string;
}

window.commandPanelActive = "Chat";

const timerProps = {
    color: "red",
    fontSize: 13
};

export default (props: HeaderProps): JSX.Element => {

    const btnChat: HTMLDivElement | null = document.querySelector("#Chat");
    const btnRatings: HTMLDivElement | null = document.querySelector("#Ratings");
    const closeButton: HTMLDivElement | null = document.querySelector("#closeButton");
    const screenSection: HTMLDivElement | null = document.querySelector(".ScreenSection ");
    const userSection: HTMLDivElement | null = document.querySelector(".UserSection");
    const activeScreenShare = props.screenShareStreams && props.screenShareStreams.length === 1;

    //Timer
    // stop it when needed
    //const Ref = useRef(null);
    const Ref = useRef<NodeJS.Timeout>();


    const [timer, setTimer] = useState('00 : 00 : 00');
    const [dynamicTime, setdynamicTime] = useState('00 : 00 : 00');
    const [showAlertBanner, setshowAlertBanner] = useState(false);
    //  const Timer = () => {

    // We need ref in this, because we are dealing
    // with JS setInterval to keep track of it and
    // stop it when needed
    //const Ref = useRef(null);

    // The state for our timer


    const getTimeRemaining = (e: Date) => {
        const total = Date.parse(e.toString()) - Date.parse(new Date().toString());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / 1000 / 60 / 60) % 24);
        const getTime = modelone.videoInterviewDetail;
        if (getTime != undefined) {
            getTime.timer = `${hours}:${minutes}:${seconds}`;
            modelone.videoInterviewDetail = getTime;
        }
        return {
            total, hours, minutes, seconds
        };
    }


    const startTimer = (e: Date) => {

        const { total, hours, minutes, seconds }
            = getTimeRemaining(e);

        if (!isOpenPopup && total == 300000 && uRole == "Interviewer") {
            togglePopupClose();
        }
        if (total <= 60000) {
            setshowAlertBanner(true);
        }
        if (total <= 0) {
            if (uRole == "Candidate" || uRole == "Spoc") {
                endCallHandler();
            }
            setIsEndCall(true);
        }
        if (modelone.videoInterviewDetail?.scheduleDate != undefined) {

            //const istDate = new Date(modelone.videoInterviewDetail?.scheduleDate);

            //date shifting for IST timezone (+5 hours and 30 minutes)
            //istDate.setHours(istDate.getHours() + 5);
            //istDate.setMinutes(istDate.getMinutes() + 30);

            ////Add 2 hours for interview
            //istDate.setHours(istDate.getHours() + 2);

            //if (istDate <= new Date()) {
            //    endCallHandler();
            //}

            let expiryDateTimestamp = Date.parse(modelone.videoInterviewDetail?.scheduleDate.toString());
            //const currentUtcTimestamp = GetCurrentUtcTimestamp();
            
            //Add 2 hours for interview
            expiryDateTimestamp = expiryDateTimestamp + (1000 * 60 * 60 * 2);
            if (expiryDateTimestamp <= window.currentTimestamp) {
                endCallHandler();
            }
        }
       

        if (total >= 0) {

            // update the timer
            // check if less than 10 then we need to
            // add '0' at the beginning of the variable

            setTimer(
                (hours > 9 ? hours : '0' + hours) + ' : ' +
                (minutes > 9 ? minutes : '0' + minutes) + ' : '
                + (seconds > 9 ? seconds : '0' + seconds)
            )
        }
    }


    const clearTimer = (e: Date) => {

        // If you adjust it you should also need to
        // adjust the Endtime formula we are about
        // to code next

        setTimer(dynamicTime)

        // If you try to remove this line the
        // updating of timer Variable will be
        // after 1000ms or 1sec
        //Ref.current : Timeout | null;



        //  if (Ref.current) clearInterval(Ref.current);

        if (Ref.current)
            clearInterval(Ref.current);

        const timeoutId = setInterval(() => {
            startTimer(e);
            window.currentTimestamp = Math.floor(window.currentTimestamp) + 1000;
        }, 1000)
        Ref.current = timeoutId;
    }

    const getDeadTime = () => {
        let deadline = new Date();
        deadline = new Date();
        // This is where you need to adjust if
        // you entend to add more time

        //Interview Time Split
        const getTimer = modelone.videoInterviewDetail;

        if (getTimer != null) {
            if (getTimer.expiryDate != null) {
                //const currentDate = new Date();

                //const utcDate = new Date(
                //    currentDate.getUTCFullYear(),
                //    currentDate.getUTCMonth(),
                //    currentDate.getUTCDate(),
                //    currentDate.getUTCHours(),
                //    currentDate.getUTCMinutes(),
                //    currentDate.getUTCSeconds()
                //);
                //const currentNumber = Math.floor(utcDate.getTime());
                //const currentNumber = Date.parse(currentUTCTime.toString());
                const currentNumber = window.currentTimestamp;
                const expiryNumber = Date.parse(getTimer.expiryDate.toString());

                const remindingNumber = expiryNumber - currentNumber;
                if (remindingNumber > 0) {

                    const seconds = Math.floor((remindingNumber / 1000) % 60);
                    const minutes = Math.floor((remindingNumber / 1000 / 60) % 60);
                    const hours = Math.floor((remindingNumber / 1000 / 60 / 60) % 24);

                    const timeStemp = `${hours}:${minutes}:${seconds}`;
                    setdynamicTime(timeStemp);
                    getTimer.timer = timeStemp;

                    deadline.setHours(deadline.getHours() + hours);
                    deadline.setMinutes(deadline.getMinutes() + minutes);
                    deadline.setSeconds(deadline.getSeconds() + seconds);
                    modelone.videoInterviewDetail = getTimer;
                    //timerArray [0] as Hours, [1] as Minutes and [0] as Seconds
                    //const timearr = getTimer.timer.split(":");
                    //
                    //if (timearr.length > 0) {
                    //    deadline.setHours(deadline.getHours() + Number(timearr[0]));
                    //    deadline.setMinutes(deadline.getMinutes() + Number(timearr[1]));
                    //    deadline.setSeconds(deadline.getSeconds() + Number(timearr[2]));
                    //}
                }
            }
        }

        return deadline;
    }

    // We can use useEffect so that when the component
    // mount the timer will start as soon as possible

    // We put empty array to act as componentDid
    // mount only
    useEffect(() => {
        clearTimer(getDeadTime());
    }, []);

    useEffect(() => {
        if (screenSection != null && modelone.isMobile == "true" && activeScreenShare) {
            if (props.selectedPane == CommandPanelTypes.Chat) {
                screenSection.style.display = "none";
            }
            else {
                screenSection.style.display = "block";
            }
        }

    }, [props.selectedPane]);

    // Another way to call the clearTimer() to start
    // the countdown is via action event from the
    // button first we create function to be called
    // by the button
    const onClickReset = () => {
        clearTimer(getDeadTime());
    }

    const modelone: ParticipantInfo = ParticipantModel();


    // }

    const ShowHideChat = (selectedPane: string): void => {

        const divChat: HTMLDivElement | null = document.querySelector("#chatAndProDiv");
        const RightDiv: HTMLDivElement | null = document.querySelector("#RightDiv");
        if (userSection != null) {
            if (selectedPane == CommandPanelTypes.Ratings || selectedPane == CommandPanelTypes.ProblemStatement)
                userSection.style.display = "none";
            else
                userSection.style.display = "block";
        }

        //const btnChat: HTMLDivElement = document.querySelector("#Chat");
        if (divChat) {
            if (selectedPane == CommandPanelTypes.Chat) {

                if (modelone.isMobile == "true") {
                    const vdoGallery: HTMLDivElement | null = document.querySelector("#div1");
                    if (vdoGallery)
                        vdoGallery.style.display = "none";

                    const msOverlay: HTMLDivElement | null = document.querySelector(".ms-Overlay");
                    if (msOverlay)
                        msOverlay.style.display = "none";
                }

                btnChat?.classList.add('linkIsSelected-202');
                document?.getElementById("div1")?.classList.remove('col-md-3');
                document?.getElementById("div1")?.classList.remove('div1Padding');
                document?.getElementById("div1")?.classList.add('col-md-2');
                document?.getElementById("divCode")?.classList.remove('col-md-9');
                document?.getElementById("divCode")?.classList.add('col-md-7');
                document?.getElementById("divCode")?.classList.remove('divCodePadding');
                divChat.style.display = "block";

                if (RightDiv) {

                    RightDiv.style.display = "none";
                }

            }
            else {
                divChat.style.display = "none";
                if (RightDiv) {
                    RightDiv.style.display = "block";
                }

                if (modelone.isMobile == "true") {
                    const vdoGallery: HTMLDivElement | null = document.querySelector("#div1");
                    if (vdoGallery)
                        vdoGallery.style.display = "block";

                    const msOverlay: HTMLDivElement | null = document.querySelector(".ms-Overlay");
                    if (msOverlay)
                        msOverlay.style.display = "";

                }
                if (btnChat != null) {

                    btnChat.classList.remove('linkIsSelected-202');
                }
                document?.getElementById("div1")?.classList.remove('col-md-2');
                document?.getElementById("div1")?.classList.add('col-md-3');
                document?.getElementById("div1")?.classList.add('div1Padding');
                document?.getElementById("divCode")?.classList.remove('col-md-7');
                document?.getElementById("divCode")?.classList.add('col-md-9');
                document?.getElementById("divCode")?.classList.add('divCodePadding');
            }
        }
    }

    const togglePeople = (selectedPane: string, setSelectedPane: (pane: string) => void): void => {

        const divChat: HTMLDivElement | null = document.querySelector("#chatAndProDiv");
        if (divChat) {
            if (selectedPane !== CommandPanelTypes.Settings) {
                divChat.style.display = "none";
                if (btnChat != null) {
                    btnChat.classList.remove('linkIsSelected-202');
                }
                document?.getElementById("div1")?.classList.remove('col-md-2');
                document?.getElementById("div1")?.classList.add('col-md-3');
                document?.getElementById("div1")?.classList.add('div1Padding');
                document?.getElementById("divCode")?.classList.remove('col-md-7');
                document?.getElementById("divCode")?.classList.add('col-md-9');
                document?.getElementById("divCode")?.classList.add('divCodePadding');

            }
            else {
                if (btnChat != null) {
                    btnChat.classList.add('linkIsSelected-202');
                }
                document?.getElementById("div1")?.classList.remove('col-md-3');
                document?.getElementById("div1")?.classList.remove('div1Padding');
                document?.getElementById("div1")?.classList.add('col-md-2');
                document?.getElementById("divCode")?.classList.remove('col-md-9');
                document?.getElementById("divCode")?.classList.add('col-md-7');
                document?.getElementById("divCode")?.classList.remove('divCodePadding');
                divChat.style.display = "block";
            }
        }
        return selectedPane !== CommandPanelTypes.People
            ? setSelectedPane(CommandPanelTypes.People)
            : setSelectedPane(CommandPanelTypes.None);
    };

    const toggleChat = (selectedPane: string, setSelectedPane: (pane: string) => void): void => {
        if (selectedPane !== CommandPanelTypes.Chat) {
            ShowHideChat(CommandPanelTypes.Chat);
            if (closeButton != null)
                closeButton.style.display = "block";
        }
        else {
            ShowHideChat(CommandPanelTypes.None);
            if (closeButton != null)
                closeButton.style.display = "none";
        }


        return selectedPane !== CommandPanelTypes.Chat
            ? setSelectedPane(CommandPanelTypes.Chat)
            : setSelectedPane(CommandPanelTypes.None);
    };

    const toggleRatings = (selectedPane: string, setSelectedPane: (pane: string) => void): void => {

        if (selectedPane !== CommandPanelTypes.Ratings) {
            ShowHideChat(CommandPanelTypes.Ratings);
            if (closeButton != null)
                closeButton.style.display = "block";
        }
        else {
            if (closeButton != null)
                closeButton.style.display = "none";

            if (userSection != null) {
                userSection.style.display = "block";
            }
        }
        return selectedPane !== CommandPanelTypes.Ratings
            ? setSelectedPane(CommandPanelTypes.Ratings)
            : setSelectedPane(CommandPanelTypes.None);
    };
    const toggleProblemStatement = (selectedPane: string, setSelectedPane: (pane: string) => void): void => {
        if (selectedPane !== CommandPanelTypes.ProblemStatement) {
            ShowHideChat(CommandPanelTypes.ProblemStatement);
            if (closeButton != null)
                closeButton.style.display = "block";
        }
        else {
            if (closeButton != null)
                closeButton.style.display = "none";

            if (userSection != null) {
                userSection.style.display = "block";
            }
        }

        return selectedPane !== CommandPanelTypes.ProblemStatement
            ? setSelectedPane(CommandPanelTypes.ProblemStatement)
            : setSelectedPane(CommandPanelTypes.None);
    };

    const toggleOptions = (selectedPane: string, setSelectedPane: (pane: string) => void): void => {

        if (selectedPane !== CommandPanelTypes.Settings) {
            ShowHideChat(CommandPanelTypes.Settings);
        }

        return selectedPane !== CommandPanelTypes.Settings
            ? setSelectedPane(CommandPanelTypes.Settings)
            : setSelectedPane(CommandPanelTypes.None);
    };

    const handleLocalVideoOnOff = async (): Promise<void> => {
        if (props.localVideoStream) {
  
            isBlur = false;

            await props.call.stopVideo(props.localVideoStream);


            props.setLocalVideoStream(undefined);

            if (window.isCameraOn == "none") {

                window.isCameraOn = "true"

                if (window.vdInfo != null) {
                    startVideo(window.vdInfo);
                }

            }
            else {
                window.isCameraOn = "false";
            }

        } else {
            if (props.videoDeviceInfo) {


                window.isCameraOn = "true";

                //if (window.adInfo != null) {
                //const localAudioStream = new LocalAudioStream(window.adInfo);
                //await props.call.startAudio(localAudioStream);
                //}



                //ConsoleFile(localVideoStream);


                //console.log(props.videoDeviceInfo);

                startVideo(window.vdInfo == null ? props.videoDeviceInfo : window.vdInfo);


            }
        }
    };

    async function startVideo(vdDeviceInfo: VideoDeviceInfo) {
        await blurEffectStop();
        const localVideoStream = new LocalVideoStream(vdDeviceInfo);
        _localVideoStream = localVideoStream;


        props.setLocalVideoStream(localVideoStream);

    

        await props.call.startVideo(localVideoStream);
    }

    const getEncCodeFromUrl = (): string | null => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('q');
    };

    const handleMuteOnOff = async (): Promise<void> => {

        if (!props.mic == true) {
            if (window.adInfo != null) {

                const localAudioStream = new LocalAudioStream(window.adInfo);
                await props.call.startAudio(localAudioStream);

            }
        }

        props.setMic(!props.mic);
    };

    const handleScreenSharingOnOff = (): void => {
        props.setScreenShare(!props.shareScreen);
    };


    const SECOND = 1000;
    const MINUTE = SECOND * 60;
    const HOUR = MINUTE * 60;
    const DAY = HOUR * 24;

    //const Timer = () => {
    //    console.log("Timer Called");
    //    const deadline = "December, 31, 2022";
    //    const parsedDeadline = useMemo(() => Date.parse(deadline), [deadline]);
    //    const [time, setTime] = useState(parsedDeadline - Date.now());

    //    useEffect(() => {
    //        const interval = setInterval(
    //            () => setTime(parsedDeadline - Date.now()),
    //            1000,
    //        );

    //        return () => clearInterval(interval);
    //    }, []);

    //    return (
    //        <div className="timer">
    //            {Object.entries({
    //                Days: time / DAY,
    //                Hours: (time / HOUR) % 24,
    //                Minutes: (time / MINUTE) % 60,
    //                Seconds: (time / SECOND) % 60,
    //            }).map(([label, value]) => (
    //                <div key={label} className="col-4">
    //                    <div className="box">
    //                        <p>{`${Math.floor(value)}`.padStart(2, "0")}</p>
    //                        <span className="text">{label}</span>
    //                    </div>
    //                </div>
    //            ))}
    //        </div>
    //    );
    //};


    useEffect(() => {
        if (props.call && props.call.localVideoStreams.length === 0 && props.localVideoStream ) {
            props.call.startVideo(props.localVideoStream);
        }
    }, [props.call, props.localVideoStream]);


    useEffect(() => {
        if (props.call && window.adInfo != null && props.mic) {

            const localAudioStream = new LocalAudioStream(window.adInfo);
            props.call.startAudio(localAudioStream);

        }
    }, [window.adInfo]);

    if (btnChat) {
        if (props.selectedPane !== CommandPanelTypes.Settings) {
            btnChat.classList.add('linkIsSelected-202');
        }
        else {
            btnChat.classList.remove('linkIsSelected-202');
        }
    }

    if (btnRatings) {
        if (props.selectedPane !== CommandPanelTypes.Settings && props.selectedPane !== CommandPanelTypes.Chat) {
            btnRatings.classList.add('linkIsSelected-202');
        }
        else {
            btnRatings.classList.remove('linkIsSelected-202');
        }
    }



    const [bannerMessages, setBannerMessages] = useState({ Header: '', Message: 'Before you leave/submit this interview, please give feedback of the candidate', LinkText: '' });

    //let bannerVisiblilty = true;

    //const dismissBanner = () => {
    //    bannerVisiblilty = false;
    //};
    let bannerDivShowCount = 0;
    bannerDivShowCount = 1;
    let showbanner = true;
    showbanner = true;
    const [showBanner, setBannerVisiblilty] = useState(true);
    const dismissBanner = () => {
        setBannerVisiblilty(false);
        let banner_Notify = document.getElementById("bannerDiv") as HTMLElement;
        banner_Notify = document.getElementById("bannerDiv") as HTMLElement;
        banner_Notify.style.display = "none";
        setshowAlertBanner(false);
    }

    const [isOpenPopup, setIsOpenPopup] = useState(false);
    const [isEndCall, setIsEndCall] = useState(false);

    const togglePopupClose = () => {
        setIsOpenPopup(!isOpenPopup);
    }

    const confirmEndCalltoggle = () => {
        if (isEndCall)
            endCallHandler();
        setIsEndCall(!isEndCall);
    }

    const updatetimeButton = async () => {
        if (timeInput != "" && timeInput != null && !isNaN(Number(timeInput)) && Number(timeInput) >= 0) {
            const checkTime = checkInterviewTime(Number(timeInput));
            if (checkTime < 0) {
                await timeCalculation(Math.floor(Number(timeInput)).toString(),false);
                UpdateInterviewTime(timeInput);
                await clearTimer(await getDeadTime());
                await togglePopupClose();
                connection.send("UpdateInterviewTime", uriGid, modelone.videoInterviewDetail?.timer, modelone.videoInterviewDetail?.expiryDate);
                setTimeInput("");
                setshowAlertBanner(false);
            }
            else {
                showErrorBlock(`The interview is 2 hours of time limit i.e. 120 minutes. There are currently ${checkTime} minutes available for this interview.`);
            }

        }
        else {
            showErrorBlock("Please enter Valid value");
        }
    }

    const extendInterviewTime = async () => {
        let defaultMin = "1";
        let isUpdateTime = false;
        if (modelone.videoInterviewDetail?.scheduleDate != undefined) {
            const scDate = new Date(modelone.videoInterviewDetail?.scheduleDate);
            const exDate = new Date(modelone.videoInterviewDetail?.expiryDate);
            if (exDate != undefined && scDate != undefined) {
                const leftMin = checkInterviewTime(10);
                if (leftMin > 0)
                    exDate.setMinutes(exDate.getMinutes() + leftMin);
                else
                    exDate.setMinutes(exDate.getMinutes() + 10);

                scDate.setHours(scDate.getHours() + 2);
                if (scDate?.getTime() >= exDate?.getTime()) {

                    isUpdateTime = true;
                    if (leftMin > 0 && leftMin < 10)
                        defaultMin = leftMin.toString();
                    else
                        defaultMin = "10";
                }
            }
        }
        await timeCalculation(defaultMin, true);
        if (isUpdateTime)
            UpdateInterviewTime(defaultMin);
        await clearTimer(await getDeadTime());
        setIsEndCall(false);
        connection.send("UpdateInterviewTime", uriGid, modelone.videoInterviewDetail?.timer, modelone.videoInterviewDetail?.expiryDate);
        setshowAlertBanner(false);
    }

    const showErrorBlock = (errorMessage: string) => {
        const errorDiv: HTMLDivElement | null = document.querySelector("#popupErrorMessage");
        if (errorDiv != null) {
            errorDiv.style.display = "block";
            errorDiv.innerHTML = errorMessage;
        }
    }

    const checkInterviewTime = (minutes: number) => {
        const details = modelone.videoInterviewDetail;
        if (details != undefined) {
            let totel = new Date(details.expiryDate).getTime() - new Date(details.scheduleDate).getTime();
            const leftMinutes = (7200000 - totel) / 60000;
            totel = totel + (minutes * 60000);
            if (totel > 7200000) {
                return leftMinutes;
            }
        }
        return -1;
    }

    const timeCalculation = (timeFloot: string, isZero: boolean) => {
        if (modelone.videoInterviewDetail != null) {

            let timer = modelone.videoInterviewDetail.timer;
            if (isZero)
                timer = "00:00:00";
            const timerarr = timer.split(":");
            const getminute = Number(timerarr[1]);
            const totelminute = getminute + Number(timeFloot);

            const hours = Math.floor(totelminute / 60) % 24;
            const minute = totelminute - hours * 60;

            const addhours = Number(timerarr[0]) + hours;
            modelone.videoInterviewDetail.timer = addhours + " : " + minute + " : " + timerarr[2];

            const expiryDate = new Date(modelone.videoInterviewDetail.expiryDate);
            expiryDate.setMinutes(expiryDate.getMinutes() + Number(timeFloot));
            modelone.videoInterviewDetail.expiryDate = expiryDate;
        }
    }

    connection.on("sendInterviewTime", async (time: string, expiryDate: Date) => {
        if (modelone.videoInterviewDetail != null) {
            modelone.videoInterviewDetail.timer = time;
            modelone.videoInterviewDetail.expiryDate = expiryDate;
            await clearTimer(await getDeadTime());
        }
    });

    const [timeInput, setTimeInput] = useState("");

    const showBannerHandler = () => setBannerVisiblilty(true); 

    const endCallHandler = () => {
        let codeQ: string | null = "";
        codeQ = getEncCodeFromUrl();
        (async () => {
            await chatAdd(codeQ);
        })().then(function () {

            if (modelone.role == "Spoc") {
                LeaveInterviewCall();
            }
            else {
                postinterviewcomplete(codeQ);
            }
            if (props.localVideo) handleLocalVideoOnOff();
            props.endCall();
            props.resetRecordingStatus();
        });
        //showbanner = modelone.role != "Interviewer" ? false : (modelone.status != undefined && modelone.status > 2) || ShowHideEndCallBanner() > 1 ? false : true;
        //if (!showbanner) {
            
        //}
        //else {
        //    bannerDivShowCount = 2;
        //    showbanner = false;
        //    let banner_Notify = document.getElementById("bannerDiv") as HTMLElement;
        //    banner_Notify = document.getElementById("bannerDiv") as HTMLElement;
        //    banner_Notify.style.display = "block";
        //}
    }

    var popupBodyContent = () => {
        return (
            <div className="form-group">
                <label>Extend Interview By Minutes:</label>
                <input type="number" className="form-control"
                    onChange={e => setTimeInput(e.target.value)}
                    style={{ marginBottom: '5px' }}
                />
                <span id="popupErrorMessage" style={{ color: 'red', fontSize: '14px', display: 'none' }}></span>
            </div>
        );
    }

    var confirmEndCallBodyContent = () => {
        return (
            <div className="form-group">
                <label>Would you like to extend this interview for 10 minutes?</label><br />
                <span> Click yes to continue. </span><br />
                <span> Click no to end the interview. </span>
            </div>
        );
    }



    return (
        <div>
            <Stack
                id="header"
                className={props.screenWidth > Constants.MINI_HEADER_WINDOW_WIDTH ? headerContainer : headerCenteredContainer}
            >
                <div
                    style={{ textOverflow: "clip"}}
                    className={props.screenWidth > Constants.MINI_HEADER_WINDOW_WIDTH ? timerDiv : timerMobileDiv}
                >
                    <span>{timer}</span>
                </div>
                <div
                    className={props.screenWidth > Constants.MINI_HEADER_WINDOW_WIDTH ? headerContainer : headerCenteredContainer}
                    style={{ display: "flex", paddingRight: "10px" }}
                >
                    {props.screenWidth < Constants.MINI_HEADER_WINDOW_WIDTH && (
                        <Stack className={mediaControlStyles}>
                            <CommandButton
                                style={{ display: 'none', marginRight: "35px" }}
                                id="closeButton"
                                className={controlButtonStyle}
                                onClick=
                                {(): void => {
                                    const miscIcon = document.getElementsByClassName("userStreamMicSection");
                                    const userSection: HTMLDivElement | null = document.querySelector(".UserSection");
                                    if (userSection != null) 
                                        userSection.style.display = "block";
                                    
                                    if (miscIcon != null) {
                                        for (var i = 0; i < miscIcon.length; i++) {
                                            var div = miscIcon[i] as HTMLDivElement;
                                            div.style.display = "Block";
                                        }
                                    }
                                    if (closeButton != null)
                                        closeButton.style.display = "none";

                                    if (props.selectedPane == CommandPanelTypes.ProblemStatement && modelone.role != "Spoc") {
                                        toggleProblemStatement(props.selectedPane, props.setSelectedPane);
                                        window.commandPanelActive = props.selectedPane !== CommandPanelTypes.ProblemStatement ? "problemstatement" : "";
                                        ShowHideBadge("problemstatement", "none");
                                    }
                                    if (props.selectedPane == CommandPanelTypes.Settings) {
                                        toggleOptions(props.selectedPane, props.setSelectedPane);
                                    }
                                    if (props.selectedPane == CommandPanelTypes.Chat) {
                                        toggleChat(props.selectedPane, props.setSelectedPane);
                                    }
                                    if (props.selectedPane == CommandPanelTypes.Ratings && modelone.role == "Interviewer") {
                                        toggleRatings(props.selectedPane, props.setSelectedPane);
                                        window.commandPanelActive = "";
                                    }
                                }}
                            >
                                <div className={fullWidth}>
                                    <UserFriendsIcon size="medium" />
                                </div>
                            </CommandButton>
                        </Stack>
                    )}

                    <Pivot
                        onKeyDownCapture={(e): void => {
                            if ((e.target as HTMLElement).id === CommandPanelTypes.People && e.keyCode === 39) e.preventDefault();
                        }}
                        getTabId={(itemKey: string): string => itemKey}
                        onLinkClick={(item): void => {
                            const miscIcon = document.getElementsByClassName("userStreamMicSection");
                           
                            if (!item) return;
                            if (item.props.itemKey === CommandPanelTypes.Settings)
                                toggleOptions(props.selectedPane, props.setSelectedPane);
                            if (item.props.itemKey === CommandPanelTypes.People) togglePeople(props.selectedPane, props.setSelectedPane);
                            if (item.props.itemKey === CommandPanelTypes.Chat) {

                                toggleChat(props.selectedPane, props.setSelectedPane);
                                window.commandPanelActive = props.selectedPane !== CommandPanelTypes.Chat ? "chat" : "";
                            }
                            if (item.props.itemKey === CommandPanelTypes.Ratings && modelone.role == "Interviewer") {
                                toggleRatings(props.selectedPane, props.setSelectedPane);

                                window.commandPanelActive = "";
                            }
                            if (item.props.itemKey === CommandPanelTypes.ProblemStatement && (modelone.role == "Candidate" || (modelone.role == "Interviewer" && modelone.isMobile == "true"))) {
                                toggleProblemStatement(props.selectedPane, props.setSelectedPane);

                                window.commandPanelActive = props.selectedPane !== CommandPanelTypes.ProblemStatement ? "problemstatement" : "";
                            }
                            if (props.selectedPane == CommandPanelTypes.ProblemStatement) {
                                ShowHideBadge("problemstatement", "none");
                            }
                            else if (props.selectedPane === CommandPanelTypes.Chat) {
                                ShowHideBadge("chat", "none");
                            }

                            if (miscIcon != null) {
                                for (var i = 0; i < miscIcon.length; i++) {
                                    var div = miscIcon[i] as HTMLDivElement;
                                    div.style.display = "Block";

                                    if (item.props.itemKey === CommandPanelTypes.ProblemStatement && props.selectedPane != CommandPanelTypes.ProblemStatement) {
                                        div.style.display = "none";
                                    }
                                }
                                //miscIcon.style.display = "Block";
                                //if (item.props.itemKey === CommandPanelTypes.ProblemStatement && props.selectedPane != CommandPanelTypes.ProblemStatement) {
                                //    miscIcon.style.display = "none";
                                //}
                            }

                        }}

                        styles={pivotItemStylesInter} /*styles={modelone.role == "Interviewer" ? pivotItemStylesInter : pivotItemStyles}*/
                        //style={{ width: modelone.isMobile == 'true' ? '5.55rem' : '10.25rem' }}
                        initialSelectedKey={CommandPanelTypes.Chat}
                        selectedKey={props.selectedPane}
                    >
                        {/*<div className="Aapp" style={timerProps}>*/}
                        {/*    <h4>{timer}</h4>*/}

                        {/*</div>*/}
                        {props.screenWidth > Constants.MINI_HEADER_WINDOW_WIDTH ? (
                            <PivotItem
                                itemKey={CommandPanelTypes.Settings}
                                onRenderItemLink={(): JSX.Element => (
                                    <SettingsIcon
                                        outline={props.selectedPane === CommandPanelTypes.Settings ? false : true}
                                        size="medium"
                                        className={props.screenWidth > Constants.MINI_HEADER_WINDOW_WIDTH ? pivotItemStyle : pivotItemStyleMobile}
                                    />
                                )}
                            />
                        ) : (
                            <PivotItem
                                itemKey={CommandPanelTypes.Settings}
                                onRenderItemLink={(): JSX.Element => (
                                    <div></div>
                                )}
                            />
                        )}

                        {/*<PivotItem*/}
                        {/*  itemKey={CommandPanelTypes.People}*/}
                        {/*  onRenderItemLink={(): JSX.Element => (*/}
                        {/*    <UserFriendsIcon*/}
                        {/*      outline={props.selectedPane === CommandPanelTypes.People ? false : true}*/}
                        {/*      size="medium"*/}
                        {/*      className={pivotItemStyle}*/}
                        {/*    />*/}
                        {/*  )}*/}
                        {/*/>*/}
                        <PivotItem
                            itemKey={CommandPanelTypes.Chat}
                            onRenderItemLink={(): JSX.Element => (
                                <div style={{ display: 'contents' }}>
                                    <ChatIcon
                                        outline={props.selectedPane === CommandPanelTypes.Chat ? false : true}
                                        size="medium"
                                        className={props.screenWidth > Constants.MINI_HEADER_WINDOW_WIDTH ? pivotItemStyle : pivotItemStyleMobile}
                                    >

                                    </ChatIcon>
                                    <Badge pill id="chatBadge" variant="primary" style={{
                                        position: 'absolute',
                                        top: '14px',
                                        right: '9px',
                                        color: '#d74654',
                                        backgroundColor: '#d74654',
                                        fontSize: '3px',
                                        padding: '3px 0px',
                                        display: 'none'

                                    }}>
                                        3
                                    </Badge>
                                </div>
                            )}
                        />
                    {(modelone.role == "Interviewer" && props.screenWidth < Constants.MINI_HEADER_WINDOW_WIDTH ) && (
                            <PivotItem
                                itemKey={CommandPanelTypes.Ratings}
                                onRenderItemLink={(): JSX.Element => (
                                    <StarIcon
                                        outline={props.selectedPane === CommandPanelTypes.Ratings ? false : true}
                                        size="medium"
                                        className={props.screenWidth > Constants.MINI_HEADER_WINDOW_WIDTH ? pivotItemStyle : pivotItemStyleMobile}
                                    />
                                )}
                            />
                        )}
                        {(modelone.role == "Candidate" || (modelone.role == "Interviewer" && modelone.isMobile == "true")) && (
                            <PivotItem
                                itemKey={CommandPanelTypes.ProblemStatement}
                                onRenderItemLink={(): JSX.Element => (

                                    <div style={{ display: 'contents' }}>
                                        <QuestionCircleIcon
                                            outline={props.selectedPane === CommandPanelTypes.ProblemStatement ? false : true}
                                            size="medium"
                                            className={props.screenWidth > Constants.MINI_HEADER_WINDOW_WIDTH ? pivotItemStyle : pivotItemStyleMobile}
                                        />
                                        <Badge pill id="problemStatementBadge" variant="primary" style={{
                                            position: 'absolute',
                                            top: '14px',
                                            right: '9px',
                                            color: '#d74654',
                                            backgroundColor: '#d74654',
                                            fontSize: '3px',
                                            padding: '3px 0px',
                                            display: 'none'

                                        }}>
                                            3
                                        </Badge>
                                    </div>

                                )}
                            />
                        )}
                        <PivotItem itemKey={CommandPanelTypes.None} />
                    </Pivot>
                    <CallRecording />
                    {props.screenWidth > Constants.MINI_HEADER_WINDOW_WIDTH && (
                        <div className={separatorContainerStyle}>
                            <Separator styles={separatorStyles} vertical={true} />
                        </div>
                    )}

                    <MediaControls
                        micActive={props.mic}
                        onMicChange={handleMuteOnOff}
                        cameraActive={props.localVideoStream !== undefined}
                        onCameraChange={handleLocalVideoOnOff}
                        screenShareActive={props.shareScreen}
                        activeScreenShareStream={props.screenShareStreams[0] ?? undefined}
                        onScreenShareChange={handleScreenSharingOnOff}
                        onEndCallClick={(): void => {
                            endCallHandler();
                            //debugger;
                            //if (modelone.role == "Interviewer" && (bannerDivShowCount > 1 || (modelone.status != undefined && modelone.status > 2))) {
                            //    showbanner = false;
                            //}
                            //showbanner = modelone.role != "Interviewer" ? false : (modelone.status != undefined && modelone.status > 2) || ShowHideEndCallBanner() > 1 ? false : true;
                            //if (!showbanner) {
                            //    let codeQ: string | null = "";
                            //    codeQ = getEncCodeFromUrl();
                            //    (async () => {
                            //        await chatAdd(codeQ);
                            //    })().then(function () {
                            //
                            //        postinterviewcomplete(codeQ);
                            //        if (props.localVideo) handleLocalVideoOnOff();
                            //        props.endCall();
                            //        props.resetRecordingStatus();
                            //    });
                            //}
                            //else {
                            //    bannerDivShowCount = 2;
                            //    showbanner = false;
                            //    let banner_Notify = document.getElementById("bannerDiv") as HTMLElement;
                            //    banner_Notify = document.getElementById("bannerDiv") as HTMLElement;
                            //    banner_Notify.style.display = "block";
                            //}
                            //if (props.localVideo) handleLocalVideoOnOff();
                            //props.endCall();
                            //props.resetRecordingStatus();
                        }}
                        cameraPermission={props.cameraPermission}
                        microphonePermission={props.microphonePermission}
                        localVideoRendererIsBusy={props.localVideoRendererIsBusy}
                        compressedMode={props.screenWidth <= Constants.MINI_HEADER_WINDOW_WIDTH}
                        isLocalScreenShareSupportedInBrowser={props.isLocalScreenShareSupportedInBrowser}
                        screenWidth={props.screenWidth}
                        selectedPane={props.selectedPane}
                        setSelectedPane={props.setSelectedPane}
                    />
                    {/*{bannerVisiblilty && props.recordingStatus !== '' && (*/}

                    {/*)}*/}
                </div>
            </Stack>
            <Banner bannerMessages={bannerMessages} dismissBanner={dismissBanner} timerPopup={togglePopupClose} showAlertBanner={showAlertBanner} isMobile={modelone.isMobile == "true" ? true:false } />
            {/*<input type="button" className="btn btn-primery" value="Popup" onClick={ togglePopupClose}></input>*/}
            {isOpenPopup && uRole == "Interviewer" && (

                <CustomPopup
                    BodyContent={popupBodyContent}
                    btnCancel="Cancel"
                    btnConfirm="Save"
                    lblTitle="Extend Interview"
                    ConfirmHandler={updatetimeButton}
                    togglePopupClose={togglePopupClose}
                    popupHeight="auto"
                    isShowCloseButton="true" 
                />

                //<div className="popup-box">
                //    <div className="popup-box-main" style={{ width: props.screenWidth < 600 ? "80%" : props.screenWidth < 1250 ? "55%" : "30%"}}>
                //    {/*<div className="popup-box-main">*/}
                //        <div className="popup-header">
                //            <div className="popup-header-title">
                //                <b>Popup</b>
                //                <button onClick={togglePopupClose}>X</button>
                //            </div>
                //        </div>
                //        <div className="popup-body">
                //            <div className="form-group">
                //                <label>Add Interview Minutes:</label>
                //                <input type="number" className="form-control"
                //                    onChange={e => setTimeInput(e.target.value)}   
                //                />
                //                <span id="popupErrorMessage">Please enter Valid value</span>
                //            </div>
                //        </div>
                //        <div className="popup-footer">
                //            <button className="btn btn-danger btn-close" onClick={togglePopupClose}>Close</button>
                //            <button className="btn btn-primary btn-save"
                //                //onClick={UpdateInterviewTime(timeInput)}
                //                onClick={updatetimeButton}
                //            >Save</button>
                //        </div>
                //    </div>
                //</div>
            )}

            {isEndCall && uRole == "Interviewer" && (

                <CustomPopup
                    BodyContent={confirmEndCallBodyContent}
                    btnCancel="No"
                    btnConfirm="Yes"
                    lblTitle="Extended Interview"
                    ConfirmHandler={extendInterviewTime}
                    togglePopupClose={confirmEndCalltoggle}
                    popupHeight="auto"
                    isShowCloseButton="false"
                />
            )}
        </div>
    );



};

